// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.easycommerce-coupons-search-input {
    width: 600px !important;
    height: 48px;
    border: 1px solid var(--color-ec-border) !important;
    border-radius: 6px !important;
    padding: 12px !important;
    color: var(--color-ec-body) !important;
    font-family: "Inter", sans-serif;
    font-size: 16px;
    font-weight: 400;
    line-height: 26px !important;
    background: #fff;
}
.easycommerce-coupons-search-input::-moz-placeholder {
    color: var(--color-ec-placeholder) !important;
}
.easycommerce-coupons-search-input::placeholder {
    color: var(--color-ec-placeholder) !important;
}
.easycommerce-coupons-search-input:focus {
    border: 1px solid var(--color-ec-primary) !important;
    box-shadow: none !important;
    outline: none !important;
}
`, "",{"version":3,"sources":["webpack://./spa/admin/easycommerce/pages/Coupons/CouponList/style.css"],"names":[],"mappings":"AAAA;IACI,uBAAuB;IACvB,YAAY;IACZ,mDAAmD;IACnD,6BAA6B;IAC7B,wBAAwB;IACxB,sCAAsC;IACtC,gCAAgC;IAChC,eAAe;IACf,gBAAgB;IAChB,4BAA4B;IAC5B,gBAAgB;AACpB;AACA;IACI,6CAA6C;AACjD;AAFA;IACI,6CAA6C;AACjD;AACA;IACI,oDAAoD;IACpD,2BAA2B;IAC3B,wBAAwB;AAC5B","sourcesContent":[".easycommerce-coupons-search-input {\n    width: 600px !important;\n    height: 48px;\n    border: 1px solid var(--color-ec-border) !important;\n    border-radius: 6px !important;\n    padding: 12px !important;\n    color: var(--color-ec-body) !important;\n    font-family: \"Inter\", sans-serif;\n    font-size: 16px;\n    font-weight: 400;\n    line-height: 26px !important;\n    background: #fff;\n}\n.easycommerce-coupons-search-input::placeholder {\n    color: var(--color-ec-placeholder) !important;\n}\n.easycommerce-coupons-search-input:focus {\n    border: 1px solid var(--color-ec-primary) !important;\n    box-shadow: none !important;\n    outline: none !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
